// // // // import React, { useState } from "react";
// // // // import { Link } from "react-router-dom";
// // // // import { FaBars, FaTimes } from "react-icons/fa";
// // // // import "./Navbar.css";

// // // // export default function Navbar() {
// // // //   const [isOpen, setIsOpen] = useState(false);

// // // //   const toggleMenu = () => {
// // // //     setIsOpen(!isOpen);
// // // //   };

// // // //   const closeMenu = () => {
// // // //     setIsOpen(false);
// // // //   };

// // // //   return (
// // // //     <nav className="navbar">
// // // //       <div className="navbar-container">
// // // //         {/* Logo */}
// // // //         <Link to="/" className="logo">
// // // //           {/* <img src="/logo.png" alt="Logo" /> */}
// // // //           <span>Grocerry</span>
// // // //         </Link>

// // // //         {/* Desktop Nav Items */}
// // // //         <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
// // // //           {/* <li>
// // // //             <Link to="/" onClick={closeMenu}>
// // // //               Home
// // // //             </Link>
// // // //           </li> */}
// // // //            <li>
// // // //             <Link to="/about" onClick={closeMenu}>
// // // //               Analytics
// // // //             </Link>
// // // //           </li> 
// // // //           {/* <li>
// // // //             <Link to="/services" onClick={closeMenu}>
// // // //               Services
// // // //             </Link>
// // // //           </li> */}
// // // //           {/* <li>
// // // //             <Link to="/contact" onClick={closeMenu}>
// // // //               Contact
// // // //             </Link>
// // // //           </li> */}
// // // //           {/* <li>
// // // //             <Link to="/login" className="btn-login" onClick={closeMenu}>
// // // //               Login
// // // //             </Link>
// // // //           </li> */}
// // // //         </ul>

// // // //         {/* Hamburger Icon */}
// // // //         <div className="menu-icon" onClick={toggleMenu}>
// // // //           {isOpen ? <FaTimes /> : <FaBars />}
// // // //         </div>
// // // //       </div>
// // // //     </nav>
// // // //   );
// // // // }
// // // import React from "react";
// // // import { Link } from "react-router-dom";
// // // import "./Navbar.css";

// // // export default function Navbar() {
// // //   return (
// // //     <nav className="navbar">
// // //       <div className="navbar-container">

// // //         {/* Logo */}
// // //         <Link to="/" className="logo">
// // //           <span>Grocerry</span>
// // //         </Link>

// // //         {/* Right Side Menu */}
// // //         <ul className="nav-menu no-hamburger">
// // //           <li>
// // //             <Link to="/about">View Graph</Link>
// // //           </li>
// // //         </ul>

// // //       </div>
// // //     </nav>
// // //   );
// // // }

// // import React from "react";
// // import { Link } from "react-router-dom";
// // import "./Navbar.css";

// // export default function Navbar() {
// //   return (
// //     <nav className="navbar">
// //       <div className="navbar-container">

// //         {/* Logo */}
// //         <Link to="/" className="logo">
// //           <span>SG OVERSEAS</span>
// //         </Link>

        

// //       </div>
// //     </nav>
// //   );
// // }

// import React from "react";
// import { Link } from "react-router-dom";
// import "./Navbar.css";
// import { MapPin, Phone } from "lucide-react"; 
// import Logo from "../assets/sg overseas LOGO-2.png"
// export default function Navbar() {
//   return (
//     <nav className="navbar">
//       <div className="navbar-container">

//         {/* LEFT - Logo */}
//         <Link to="/" className="logo">
//           <span> <img src={Logo} /> </span>
//         </Link>

//         {/* RIGHT - Address + Mobile */}
//         <div className="nav-right">
          
//           <div className="nav-info">
//             <MapPin size={18} className="nav-icon" />
//             <span>Chhawani, Indore</span>
//           </div>

//           {/* <div className="nav-info">
//             <Phone size={18} className="nav-icon" />
//             <span>9826913258</span>
//           </div> */}
//           <a
//   href="https://wa.me/9826913258"
//   target="_blank"
//   rel="noopener noreferrer"
//   className="nav-info"
//   style={{ display: "flex", alignItems: "center", gap: "6px", textDecoration: "none", color: "inherit" }}
// >
//   <Phone size={18} className="nav-icon" />
//   <span style={{ color: " #059669" }}>9826913258</span>
// </a>


//         </div>

//       </div>
//     </nav>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { MapPin, Phone } from "lucide-react"; 
import Logo from "../assets/sg overseas LOGO-2.png";

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* LEFT LOGO */}
        <Link to="/" className="navbar-logo">
          <img src={Logo} alt="Logo" className="nav-logo-img" />
        </Link>

        {/* RIGHT CONTENT */}
        <div className="nav-right">

          <div className="nav-info">
            <MapPin size={18} className="nav-icon" />
            <span>Chhawani, Indore</span>
          </div>

          <a
            href="https://wa.me/9826913258"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-info"
          >
            <Phone size={18} className="nav-icon" />
            <span style={{ color: "#059669" }}>9826913258</span>
          </a>

        </div>

      </div>
    </nav>
  );
}
